// extracted by mini-css-extract-plugin
export default {"page":"Welldones_page__JdaA+","container":"Welldones_container__accPa","header":"Welldones_header__KtV+3","bar":"Welldones_bar__rMqJm","table":"Welldones_table__tjv6c"};